import { useCommandHandler } from "@/lib/shortcuts/solid";
import { COMMAND_IDS } from "@/lib/shortcuts/defaults";
import { undoLastAction } from "@/lib/undo";
import type { useTheme } from "@/providers/theme-provider";

interface AppShortcutsOptions {
  theme: ReturnType<typeof useTheme>;
  t: (key: string) => string;
  shortcutsOpen: () => boolean;
  setShortcutsOpen: (open: boolean) => void;
  setIsSidebarOpen: (f: (prev: boolean) => boolean) => void;
}

export function useAppShortcuts(options: AppShortcutsOptions) {
  // ── Shortcut handlers (declarative; bindings live in lib/shortcuts/defaults.ts)
  useCommandHandler(COMMAND_IDS.HELP_OPEN, () => {
    options.setShortcutsOpen(true);
  });

  // ── Undo (UNDO-TRASH-LIGHT L1): Ctrl/Cmd+Z deshace la última acción ──────
  useCommandHandler(COMMAND_IDS.UNDO, () => {
    void undoLastAction();
  });

  // ── UI toggles ─────────────────────────────────────────────────────────
  useCommandHandler(COMMAND_IDS.UI_TOGGLE_SIDEBAR, () => {
    options.setIsSidebarOpen((prev) => !prev);
  });
  useCommandHandler(COMMAND_IDS.UI_TOGGLE_BLUR, () => {
    void options.theme.toggleBlur();
  });
  useCommandHandler(COMMAND_IDS.UI_TOGGLE_FOLLOW_DEVICE_THEME, () => {
    void options.theme.toggleFollowDevice();
  });
  useCommandHandler(COMMAND_IDS.UI_TOGGLE_BACKGROUND_STYLE, () => {
    options.theme.toggleBackgroundStyle();
  });
}
